<template>
<!-- 메일패드 팝업 -->

<div style="width: 100%; padding: 50px 0; font-family: '맑은 고딕', 'Apple Gothic', 'malgun gothic', 'AppleGothic', 'Arial', 'Helvetica', sans-serif;">
    <div style="width: 100%; max-width: 600px; margin: 0 auto;">
        <div style="background: #f77924; width: 100%; height: 6px;"></div>
        <div style="margin-top:20px;">
            <!-- 적용할때 경로 꼭! 바꿔주세요!  -->
            <span aria-hidden="true">
                <!-- <img src="../../assets/img/close.png" alt="close" class="pointer close-btn"> -->
            </span>
            <img src="../../assets/img/logo.png" alt="carrotglobal" style="width: 130px;float:right;">

        </div>
        <div style="width: 100%; background: #ffffff;margin: 20px 0 40px 0;">
            <div style="font-size: 14px; line-height: 22px; letter-spacing: -1px;padding: 20px 30px 40px 30px;">
                <p style="font-weight: bold; font-size: 22px;margin-top:10px; margin-bottom: 20px;">{{qaDetail.sugang_name}} 문의사항 안내 드립니다.</p>

                안녕하세요. {{qaDetail.name}}님!<br>
                아래 문의 주신 내용에 대해 답변 드립니다.<br>

                <p style="background:#C8C8C8; padding: 10px; margin:20px 0px;">{{qaDetail.qa_contents}}</p>

                 {{contents}}

                 <br><br>

                감사합니다. <br>
                {{defaultManger.managerName}} 매니저 드림.
            </div>
        </div>
        <div style="width: 100%; max-width: 650px; margin: 0 auto; text-align:center; background:#303030; color:#afafaf; font-size:14px; padding:10px 0;">
            <p style="-webkit-margin-before: 0em; -webkit-margin-after: 0em; line-height:20px; margin:0;">
                <span style="font-weight: bold; color: #fff;">과정문의</span>
                {{defaultManger.managerName}} 매니저 │ {{defaultManger.email}}
            </p>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    // props: ['parentData'],
    data: () => ({
        qaDetail: {},
        defaultManger: {},
        mailPadData: {}, // 메일패드 api호출할 데이터
        qaIdx: '', // 1:1 문의 고유 idx,

      contents: ''
    }),

    mounted() {
          var oParams = GetUrlParams()
        if (typeof oParams.qaIdx === 'undefined') {
            alert('해당 페이지는 주소창으로의 진입이 불가능합니다.')
            window.close()
        }

        this.qaIdx = oParams.qaIdx
        this.contents = decodeURI(oParams.contents)
        var params = {
            qaIdx: this.qaIdx,
        }

        this.axios.get(this.axios.root + this.axios.port + `/admin/qa-detail/${this.qaIdx}`, {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.qaDetail = res.data.qaDetail
                this.defaultManger = res.data.defaultManger
                // this.company_name_direct = res.data.qaDetail.company_name_direct
                // this.sugang_name = res.data.qaDetail.sugang_name
                // this.name = res.data.qaDetail.name
                // this.mobile = res.data.qaDetail.mobile
                // this.email = res.data.qaDetail.email
                // this.qa_contents = res.data.qaDetail.qa_contents
                // this.status = res.data.qaDetail.status
                // this.pageIdx = res.data.qaDetail.idx_itm_sugang_page_main

                // if (res.data.qaDetail.as_contents) {
                //     this.as_contents = res.data.qaDetail.as_contents
                // }

                // this.managerIdx = res.data.defaultManger.idx
                // this.managerName = res.data.defaultManger.name
                // this.managerEmail = res.data.defaultManger.email

                // this.hqManagers = res.data.allHqMangerList.hqList

                // for (var manager of this.hqManagers) {
                //     if (manager.regid === res.data.defaultManger.idx) {
                //         this.selectHqManager = manager
                //     }
                // }
            } else {
                alert(res.data.err)
            }
        }).catch(err => {
            console.log(err)
            alert(err)
        })
    }
}
</script>
